import React, { useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import cs from 'classnames';
import { Link } from '@remix-run/react';
import Number from 'icon/number.svg';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { Image } from '../image';
import { formatNumByRegion } from '~/utils/format/num-formatter';
import { useTranslation } from 'react-i18next';
import { Region } from '@lemon8/web-app-shared/i18n';

import './style.scss';

const HashtagCard: React.FC<{
  aHref: string;
  name: string;
  desc?: string;
  icon_url?: string;
  className?: string;
  style?: any;
  isDefault?: boolean;
  onClick?: any;
  isBOT?: boolean;
  size?: 'default' | 'large' | 'small';
  /** 关注数 */
  followerCount?: number;
  /** 查看数 */
  viewsCount?: number;
  onImpression?: () => void;
  activity_icon_style?: number;
  showNumber?: boolean;
}> = (props) => {
  const {
    aHref = '',
    name = '',
    desc = '',
    icon_url = '',
    className = '',
    style = {},
    isBOT = false,
    isDefault = false,
    onClick = () => {
      //
    },
    size = 'default',
    followerCount = 0,
    viewsCount = 0,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onImpression = () => {},
    showNumber = false,
    activity_icon_style,
  } = props;
  const { region } = useAtomValue($Locale);

  const { t } = useTranslation();

  const hashRef = useRef<any>(null);
  let offsetTop = 0;

  const isLarge = size === 'large';
  const isSmall = size === 'small';

  const throttleHandleScroll = throttle(() => {
    // 这里的计算都是基于window滚动实现的，如果之后转移虚拟化了这里计算要想办法重新算
    if (window.scrollY + window.innerHeight > offsetTop) {
      onImpression();
      window.removeEventListener('scroll', throttleHandleScroll);
    }
  }, 300);
  useEffect(() => {
    if (hashRef.current) {
      offsetTop = window.scrollY + hashRef.current.getBoundingClientRect().y;
    }
    window.addEventListener('scroll', throttleHandleScroll);
    return () => {
      window.removeEventListener('scroll', throttleHandleScroll);
    };
  }, []);
  return (
    <Link
      to={aHref}
      className={cs('hashtag-card', className, `hashtag-card-size-${size}`)}
      style={style}
      onClick={onClick}
      ref={hashRef}
    >
      {!isSmall &&
        (isDefault ? (
          <div
            className={cs('hashtag-card-avatar', {
              default: isDefault,
            })}
          >
            <Number />
          </div>
        ) : (
          <Image src={icon_url} className={cs('hashtag-card-avatar', { isBOT })} alt={name} />
        ))}

      <div className="hashtag-card-content">
        <div className="hashtag-card-content-main">
          {isDefault ? (
            <h2 className="hashtag-card-content-name">
              {name}
              {activity_icon_style === 1 ? <i className="money-tag" /> : ''}
            </h2>
          ) : (
            <h3 className="hashtag-card-content-name">
              {name}
              {activity_icon_style === 1 ? <i className="money-tag" /> : ''}
            </h3>
          )}
          {!isSmall && <div className="hashtag-card-content-desc">{desc}</div>}
        </div>
        {isLarge ? (
          <div className="hashtag-card-content-count">
            {(viewsCount > 0 || showNumber) && (
              <span className="views">
                {t('view_count_plural', { num: viewsCount }).replace(
                  '%d',
                  formatNumByRegion(viewsCount, region as unknown as Region, t),
                )}
              </span>
            )}
            {showNumber && <span className="divider">·</span>}
            {showNumber && (
              <span className="follower">
                {t('follower_count_plural', { num: followerCount }).replace(
                  '%d',
                  formatNumByRegion(followerCount, region as unknown as Region, t),
                )}
              </span>
            )}
          </div>
        ) : null}
      </div>
    </Link>
  );
};

export default HashtagCard;
